import { gql } from "@apollo/client";

export const DELETE_SERVICE_MUTATION = gql`
  mutation DeleteServiceMutation($serviceId: String!) {
    deleteService(serviceId: $serviceId)
  }
`;
